import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from './navbar.component';
import { MaterialModule } from 'src/app/material.module';
import { RouterModule } from '@angular/router';
import { JobTypeSwitcherModule } from '../job-type-switcher/job-type-switcher.module';
import { FunctieSelectionDialogModule } from '../functie-selection-dialog/functie-selection-dialog.module';
import { DirectieTypeSwitcherModule } from '../directie-type-switcher/directie-type-switcher.module';
import { DirectieSelectionDialogModule } from '../directie-selection-dialog/directie-selection-dialog.module';

@NgModule({
    declarations: [NavbarComponent],
    imports: [
        CommonModule,
        MaterialModule,
        RouterModule,
        JobTypeSwitcherModule,
        FunctieSelectionDialogModule,
        DirectieTypeSwitcherModule,
        DirectieSelectionDialogModule,
    ],
    exports: [NavbarComponent],
})
export class NavbarModule { }
